if (!customElements.get('sticky-header')) {
  customElements.define(
    'sticky-header',
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = this.closest('.section-header');
        this.type = this.getAttribute('data-sticky-type');
        this.headerBounds = {};
        this.setHeaderHeight();
        window.addEventListener('resize', this.setHeaderHeight.bind(this));
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScroll = () => this.preventReveal = true;
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScroll);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScroll);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (this.preventHide) return;
          this.type === 'on-scroll' ? requestAnimationFrame(this.show.bind(this)) : requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => this.preventReveal = false, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        this.header.classList.add('section-header__hidden', 'section-header__sticky', 'top-0');
      }

      show() {
        this.header.classList.add('section-header__sticky', 'top-0', 'animate');
      }

      reveal() {
        this.header.classList.add('section-header__sticky', 'animate');
        this.header.classList.remove('section-header__hidden');
      }

      reset() {
        this.header.classList.remove('section-header__hidden', 'section-header__sticky', 'top-0', 'animate');
      }
    }
  );
}